import { render, staticRenderFns } from "./DragPeople.vue?vue&type=template&id=f308f582&"
import script from "./DragPeople.vue?vue&type=script&lang=js&"
export * from "./DragPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports